<template>
  <div class="upgrade-client-modal">
    <div class="modal-content">
      <!-- 标题栏 -->
      <div class="modal-header">
        <div class="title-container">
          <img class="icon" src="@/assets/images/sogou-icon.png" alt="" />
          <div class="title">PDF编辑转换器</div>
        </div>
        <div class="close-btn" @click="close">×</div>
      </div>
      
      <!-- 主体内容 -->
      <div class="modal-body">
        <p class="upgrade-text">为给您提供更优质的服务，请先升级客户端</p>
        <div class="upgrade-steps">
          <span class="step-dot">●</span>
          <span class="step-text">打开PDF阅读器 → 左上角“文件”→ 检查更新</span>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="modal-footer">
        <button class="upgrade-btn" @click="handleUpgrade">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/client'
export default {
  name: 'UpgradeClient',
  data() {
    return {
      // 可以在这里添加组件所需的数据
    }
  },
  methods: {
    close() {
      client.common.API.client_closeWindow()
    },
    handleUpgrade() {
      client.common.API.client_openKisProcessNew()
      client.common.API.client_closeWindow()
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-client-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .modal-content {
    width: 400px;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    // 标题栏
    .modal-header {
      height: 28px;
      background-color: #FDD549;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 8px;
      box-sizing: border-box;
      
      .title-container {
        display: flex;
        align-items: center;
        
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
        .title {
          font-size: 12px;
          font-weight: 400;
          color: #B07400;
        }
      }
      .close-btn {
        cursor: pointer;
        font-size: 20px;
        color: #A15938;
      }
    }
    
    // 主体内容
    .modal-body {
      padding: 28px 28px 22px 28px;
      font-size: 15px;
      font-weight: 400px;
      color: #333;
      line-height: 22px;
      
      .upgrade-text {
        margin-bottom: 4px;
      }
      .upgrade-steps {
        display: flex;
        align-items: flex-start;
        
        .step-dot {
          margin-right: 10px;
        }
      }
    }
    
    // 底部按钮
    .modal-footer {
      padding: 0 20px 20px 0;
      display: flex;
      justify-content: flex-end;
      
      .upgrade-btn {
        width: 100px;
        height: 34px;
        background-color: #63B422;
        border: none;
        border-radius: 2px;
        color: white;
        font-size: 12px;
        font-weight: 400;
        cursor: pointer;
        
        &:hover {
          background-color: darken(#7bc144, 5%);
        }
      }
    }
  }
}
</style>
